import Vue from 'vue'
import {base} from './base.js'
// 获取用户信息
export function getUserInfo () {
  return Vue.prototype.postAxios(base.USER_INFO)
}
// 编辑用户信息
export function editUserInfo (param) {
  return Vue.prototype.postAxios(base.EDIT_USER, param)
}
// 检查手机绑定状态
export function ckMobile () {
  return Vue.prototype.postAxios(base.CHECK_MOBILE)
}
// 发送验证码
export function sendCode (m, t) {
  return Vue.prototype.postAxios(base.SEND_CODE, {m, t})
}
// 绑定手机号
export function bindMobile (m, c, t) {
  return Vue.prototype.postAxios(base.BIND_MOBILE, {m, c, t})
}
// 用户账户信息
export function accountInfo () {
  return Vue.prototype.postAxios(base.ACCOUNT_INFO)
}
// 交易记录
export function getTradeRecord () {
  return Vue.prototype.postAxios(base.TRADE_RECORD)
}
// 交易记录详情
export function getTradeRecordInfo (trid) {
  return Vue.prototype.postAxios(base.TRADE_RECORD_INFO, {trid})
}
// 提现记录
export function getWithDraw (page, list_rows) {
  return Vue.prototype.postAxios(base.WITH_DRAW, {page, list_rows})
}
// 提现申请
export function withDrawApply (a_amt) {
  return Vue.prototype.postAxios(base.WITH_DRAW_APPLY, {a_amt})
}
// 提现详情
export function withDrawInfo (wid) {
  return Vue.prototype.postAxios(base.WITH_DRAW_INFO, {wid})
}
// 税金计算
export function withDrawTax (a_amt) {
  return Vue.prototype.postAxios(base.WITH_DRAW_TAX, {a_amt})
}
// 实名认证
export function realNameAuth (realname, IDCardNumber, tag) {
  return Vue.prototype.postAxios(base.REALNAME_AUTH, {realname, IDCardNumber, tag})
}
// 实名认证信息
export function realNameAuthInfo () {
  return Vue.prototype.postAxios(base.REALNAME_AUTH_INFO)
}
// 获取意见反馈
export function feedBack (page, list_rows) {
  return Vue.prototype.postAxios(base.FEED_BACK, {page, list_rows})
}
// 意见反馈详情
export function feedBackInfo (fbid) {
  return Vue.prototype.postAxios(base.FEED_BACK_INFO, {fbid})
}
// 新增意见反馈
export function creatFeedBack (type, content, contacts) {
  return Vue.prototype.postAxios(base.ADD_FEED_BACK, {type, content, contacts})
}
// 删除意见反馈
export function delFeedBack (fbid) {
  return Vue.prototype.postAxios(base.DEL_FEED_BACK, {fbid})
}
// 获取通知消息列表
export function getNotice (page, list_rows) {
  return Vue.prototype.postAxios(base.NOTICE_LIST, {page, list_rows})
}
// 设置通知消息已读
export function noticeRead (all, nmid) {
  return Vue.prototype.postAxios(base.NOTICE_READ, {all, nmid})
}
// 获取通知消息未读的数量
export function noticeUnread () {
  return Vue.prototype.postAxios(base.NOTICE_UNREAD_COUNT)
}
// 删除通知消息
export function noticeDel (params) {
  return Vue.prototype.postAxios(base.NOTICE_DEL, params)
}
// 日历列表
export function calendarList (params) {
  return Vue.prototype.postAxios(base.CALENDAR_LIST, params)
}
// 检查今日打卡状态
export function checkInStatus (params) {
  return Vue.prototype.postAxios(base.CHECK_IN_STATUS, params)
}
// 签到打卡
export function checkIn (params) {
  return Vue.prototype.postAxios(base.CHECK_IN, params)
}
// 获取用户日记列表
export function diaryList (page, list_rows) {
  return Vue.prototype.postAxios(base.DIARY_LIST, {page, list_rows})
}
// 获取用户日历详情
export function diaryInfo (did) {
  return Vue.prototype.postAxios(base.DIARY_INFO, {did})
}
// 新增、编辑日记
export function editDiary (params) {
  return Vue.prototype.postAxios(base.DIARY_EDIT, params)
}
// 删除日记
export function delDiary (did) {
  return Vue.prototype.postAxios(base.DIARY_DEL, {did})
}



// WEBPACK FOOTER //
// ./src/api/user.js